import React, { memo, useEffect } from 'react'
import { Route } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import HomeContainer from '../../../../containers/HomeContainer'
import { STAKING_URL } from '../../../../constants/navigation'
// import StakingContainer from './StakingContainer' // @TODO: Need to revert when staking ready
import StakingContainer from '../../containers/WalletContainer'
// import { getBannersGroupingData } from '../../../../store/actions/banners'
import { getMilestone } from '../../../../store/actions/rewardBox'
import { getWalletAddressSelector } from '../../../../store/selectors/wallet'

const HomeContainerWrapper = (props) => {
  const dispatch = useDispatch()
  const walletAddressMembership = useSelector(getWalletAddressSelector)

  useEffect(() => {
    const membershipNumber = walletAddressMembership.membershipNumber
    if (membershipNumber) {
      dispatch(getMilestone(membershipNumber))
    }
  }, [walletAddressMembership.membershipNumber])

  // @TODO: disabled fetching banners for qbx_vip brand, enable if needed check with Pascal
  // useEffect(() => {
  //   dispatch(getBannersGroupingData())
  // }, [])

  return (
    <HomeContainer
      {...props}
      additionalRoutes={
        <Route path={STAKING_URL} element={<StakingContainer />} />
      }
    />
  )
}

export default memo(HomeContainerWrapper)
